module.exports = __webpack_public_path__ + "img/Archive-icon.272337c0.jpg";